import React, { useState, useEffect } from 'react';
import '@/App.css';
import { AppProvider, useApp } from './context/AppContext';
import AuthPage from './pages/AuthPage';
import Landing from './pages/Landing';
import KidMode from './pages/KidMode';
import ParentDashboard from './pages/ParentDashboard';
import InstallPrompt from './components/InstallPrompt';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AppContent = () => {
  const { isAuthenticated, setIsAuthenticated } = useApp();
  const [mode, setMode] = useState('auth');
  const [user, setUser] = useState(null);
  const [authToken, setAuthToken] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAuth();
  }, []);

  useEffect(() => {
    if (authToken) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${authToken}`;
    } else {
      delete axios.defaults.headers.common['Authorization'];
    }
  }, [authToken]);

  const checkAuth = async () => {
    const token = localStorage.getItem('auth_token');
    const savedUser = localStorage.getItem('user');
    
    if (token && savedUser) {
      try {
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        const response = await axios.get(`${API}/auth/me`);
        setUser(response.data);
        setAuthToken(token);
        setIsAuthenticated(true);
        setMode('landing');
      } catch (error) {
        localStorage.removeItem('auth_token');
        localStorage.removeItem('user');
        setMode('auth');
      }
    } else {
      setMode('auth');
    }
    setLoading(false);
  };

  const handleAuthSuccess = (userData, token) => {
    setUser(userData);
    setAuthToken(token);
    setIsAuthenticated(true);
    setMode('landing');
  };

  const handleEnterKidMode = () => {
    setMode('kid');
  };

  const handleParentAuthenticated = () => {
    setIsAuthenticated(true);
    setMode('parent');
  };

  const handleLogout = () => {
    localStorage.removeItem('auth_token');
    localStorage.removeItem('user');
    delete axios.defaults.headers.common['Authorization'];
    setUser(null);
    setAuthToken(null);
    setIsAuthenticated(false);
    setMode('auth');
  };

  const handleBackToHome = () => {
    setMode('landing');
  };

  const handleBackToHomeFromKid = () => {
    setMode('landing');
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-[#FFFDF5] flex items-center justify-center">
        <div className="text-2xl font-bold text-gray-800 fredoka">Loading...</div>
      </div>
    );
  }

  return (
    <div className="App">
      {mode === 'auth' && <AuthPage onAuthSuccess={handleAuthSuccess} />}
      {mode === 'landing' && (
        <Landing
          onEnter={handleEnterKidMode}
          onAuthenticated={handleParentAuthenticated}
        />
      )}
      {mode === 'kid' && <KidMode onBack={handleBackToHomeFromKid} />}
      {mode === 'parent' && <ParentDashboard onLogout={handleLogout} onBackHome={handleBackToHome} />}
      <InstallPrompt />
    </div>
  );
};

function App() {
  return (
    <AppProvider>
      <AppContent />
    </AppProvider>
  );
}

export default App;
